import React, { useEffect, useState } from "react";
import { Placeholder, Segment, SegmentGroup, Table } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { cargarCalificacion } from "../../utils/Datos";

export const FormularioCalificacion = (props) => {
  const [calificacion, setcalificacion] = useState(null);

  useEffect(() => {
    cargarCalificacion(props.calificacion).then((c) => {
      if (c.status) {
        setcalificacion(c.datos);
      }
    });
  }, [props.calificacion]);

  return calificacion === null ? (
    <Placeholder>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </Placeholder>
  ) : (
    <>
      <h2>{calificacion.name}</h2>
     
      <Segment.Group>
        <Segment inverted color="blue">
          <h4 className="text-white">{`1) FACTOR RENDIMIENTO`}</h4>
        </Segment>
        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                <h5>a) Cantidad de Trabajo</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center" width={10}>Volumen de trabajo</Table.Cell>
                <Table.Cell textAlign="center" width={3}>
                  <b>{calificacion.volumeOfWork}</b>
                </Table.Cell>
                <Table.Cell
                  
                  rowSpan="4"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor11}</b>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Rapidez en la ejecución del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  {calificacion.speedInExecution}
                </Table.Cell>
                
                

              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Oportunidad en la ejecución del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  {calificacion.opportunityInExecution}
                </Table.Cell>
                
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 3 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>
                    {calificacion.volumeOfWork +
                      calificacion.speedInExecution +
                      calificacion.opportunityInExecution}
                  </b>
                </Table.Cell>
                
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF11}
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>b) Calidad de la Labor Realizada</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Planificación del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center">
                  {calificacion.planningWork}
                </Table.Cell>
                <Table.Cell
                  rowSpan="4"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor12}</b>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Habilidad en la ejecución del trabajo (ausencia de errores)
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  {calificacion.abilityToExecute}
                </Table.Cell>
                

              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>
                    {calificacion.planningWork + calificacion.abilityToExecute}
                  </b>
                </Table.Cell>
                

              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF12}
          </p>
        </Segment>

        <Segment.Group horizontal>
          <Segment>
            <b>Suma de 2 subfactores evaluados:</b>
          </Segment>
          <Segment>
            <b>{calificacion.subFactor11 + calificacion.subFactor12}</b>
          </Segment>

          <Segment inverted color="teal">
            <b>Nota Factor:</b>
          </Segment>
          <Segment inverted color="teal">
            <b>{(calificacion.qualificationFactor1)}</b>
          </Segment>
        </Segment.Group>
      </Segment.Group>

      <Segment.Group>
        <Segment inverted color="blue">
          <h4 className="text-white">{`2) FACTOR CONDICIONES PERSONALES`}</h4>
        </Segment>
        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>c) Conocimiento del Trabajo</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Conocimiento del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>{calificacion.jobKnowledge}</b>
                </Table.Cell>
                <Table.Cell
                  rowSpan="4"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor21}</b>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">Estudios</Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                <b>{calificacion.studies}</b>
                </Table.Cell>
                

              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Capacidad de servicio relacionada con su función
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                <b>{calificacion.serviceCapacity}</b>
                </Table.Cell>
                

              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 3 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>
                    {calificacion.jobKnowledge +
                      calificacion.studies +
                      calificacion.serviceCapacity}
                  </b>
                </Table.Cell>
                

              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF21}
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>d) Interés por el trabajo que realiza</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Capacitación voluntaria directamente relacionada con su
                  función
                </Table.Cell>
                <Table.Cell textAlign="center">
                <b>{calificacion.trainingVolunteer}</b>
                </Table.Cell>
                <Table.Cell
                  rowSpan="4"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor22}</b>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  Creatividad para solucionar problemas
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>{calificacion.creativityToSolveProblems}</b>
                </Table.Cell>
                

              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>
                    {calificacion.trainingVolunteer +
                      calificacion.creativityToSolveProblems}
                  </b>
                </Table.Cell>
                

              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF22}
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>e) Capacidad de realizar trabajos en grupo</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Facilidad de integración al equipo de trabajo
                </Table.Cell>
                <Table.Cell textAlign="center">
                  {calificacion.easyIntegration}
                </Table.Cell>
                <Table.Cell
                  rowSpan="4"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor23}</b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF23}
          </p>
        </Segment>

        <Segment.Group horizontal>
          <Segment>
            <b>Suma de 3 subfactores evaluados:</b>
          </Segment>
          <Segment>
            <b>
              {calificacion.subFactor21 +
                calificacion.subFactor22 +
                calificacion.subFactor23}
            </b>
          </Segment>

          <Segment inverted color="teal">
            <b>Nota Factor:</b>
          </Segment>
          <Segment inverted color="teal">
            <b>
              {calificacion.qualificationFactor2}
            </b>
          </Segment>
        </Segment.Group>
      </Segment.Group>

      <Segment.Group>
        <Segment inverted color="blue">
          <h4 className="text-white">{`3) FACTOR DE COMPORTAMIENTO FUNCIONARIO`}</h4>
        </Segment>
        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>f) Asistencia y puntualidad</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">Permanencia</Table.Cell>
                <Table.Cell textAlign="center">
                <b>{calificacion.permanency}</b>
                </Table.Cell>
                <Table.Cell
                  rowSpan="4"
                  colSpan="1"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor31}</b>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">Puntualidad</Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>{calificacion.punctuality}</b>
                </Table.Cell>
                
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>{calificacion.permanency + calificacion.punctuality}</b>
                </Table.Cell>
                
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF31}
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>g) Cumplimiento de normas e instrucciones</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> Concepto
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3}>
                  Notas <br /> SubFactor
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Cumplimiento de normas
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>{calificacion.standardsCompliance}</b>
                </Table.Cell>
                <Table.Cell
                  rowSpan="4"
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <b>{calificacion.subFactor32}</b>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  Cumplimiento de tareas
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>{calificacion.taskFulfillment}</b>
                </Table.Cell>
                
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center" className="pr-10">
                  <b>
                    {calificacion.standardsCompliance +
                      calificacion.taskFulfillment}
                  </b>
                </Table.Cell>
                
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b> {calificacion.commentSF32}
          </p>
        </Segment>

        <Segment.Group horizontal>
          <Segment>
            <b>Suma de 2 subfactores evaluados:</b>
          </Segment>
          <Segment>
            <b>{calificacion.subFactor31 + calificacion.subFactor32}</b>
          </Segment>

          <Segment inverted color="teal">
            <b>Nota Factor:</b>
          </Segment>
          <Segment inverted color="teal">
            <b>{calificacion.qualificationFactor3}</b>
          </Segment>
        </Segment.Group>
      </Segment.Group>
    </>
  );
};
